<style>
  #MyListMenu li {
    list-style: none;
  }

  .Lvl2 {
    margin: 10px 20px;
  }
</style>
<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات کاربر</h5>

    <button type="button" (click)="openModal_Customer(templatePersone)" class="btn btn-warning"
      style="margin-left: 5px;"> جستجوی پرسنل <i class="fa fa-user"></i> </button>

    <br>
    <br>

    <form *ngIf="selected_DataList_Persone_Record.id>0" [formGroup]="AddNewUser" (submit)="SubmitAddNewUser()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام کاربری</label>
          <input formControlName="Username" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Username().valid && get_Form_Username().touched"
            class="form-text text-muted MyErrorRedColor">نام کاربری را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">رمز عبور</label>
          <input formControlName="Password" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched"
            class="form-text text-muted MyErrorRedColor">رمز عبور را وارد نمائید. (حداقل 6 کاراکتر)</small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نوع کاربر </label>
          <select formControlName="Type" class="custom-select">
            <option value="0">انتخاب کنید</option>
            <option value="1">کاربر ارشد</option>
            <option value="2">کاربر عادی</option>
          </select>
        </div>
        <div class="form-group col-md-6" *ngIf="get_Form_Type().value!='1'">
          <label for="exampleInputEmail1"> کارشناسان کالیبراسیون </label>
          <select formControlName="ExpertCalibration" class="custom-select">
            <option value="0">اطلاعات فردی</option>
            <option value="1">همه اطلاعات</option>
          </select>
        </div>
        <div class="form-group col-md-6" *ngIf="get_Form_Type().value=='1'">
          <label for="exampleInputEmail1"> کارشناسان کالیبراسیون </label>
          <p>همه اطلاعات</p>
        </div>

      </div>



      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewUser.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
          class="fa fa-times-rectangle"></i> لغو </button>
      <button routerLink="/User" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
    <button routerLink="/User" *ngIf="selected_DataList_Persone_Record.id==0" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>
  </div>
</div>


<ng-template #templatePersone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات پرسنل </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> نام/نام خانوادگی </label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <th>علامت اختصاری در بهینه فرآیند آزما</th>
              <th>کدملی</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Persone
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Persone|filter:Filter_title:'fullname').length
                      }
            ">
              <td>{{DataList_Persone.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.almat_Ekhtesari}}</td>
              <td>{{item.codemeli}}</td>

              <td (click)="selected_DataList_Persone(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingPersone" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingPersone" type="button" (click)="ReadData_Persone()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Person.hide()">بستن</button>
  </div>
</ng-template>
